module.exports = __webpack_public_path__ + "static/tax-icon-mobile-0ac8d0bc19b980cca4913fb6ba05e376.png";